import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, Switch, Modal, Typography, Divider } from "antd";
import axios from "axios";
import { useState } from "react";

import { showErrorNotification } from "../../../utils/notification";

const ModifyUserAccessConfigModal = ({
  isModalOpen = false,
  isBulkModification = false,
  bulkModificationsEmailFileUploadAPIPath = "",
  userAccessConfig = {},
  setIsModalOpen = () => {},
  handleAccessConfigStateUpdate = () => {},
  handleUpdateUserAccessConfig = () => {},
  handleBulkUpdateUserAccessConfig = () => {}
}) => {
  const [emailsListToUpdate, setEmailsListToUpdate] = useState([]);
  const handleUpload = async (options) => {
    const { file, onSuccess, onError } = options;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(bulkModificationsEmailFileUploadAPIPath, formData, {});
      const { emails } = response.data;
      setEmailsListToUpdate(emails);
      onSuccess(response.data);
    } catch (err) {
      onError(err);
      showErrorNotification(err);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleUpdate = () => {
    if (isBulkModification) {
      handleBulkUpdateUserAccessConfig(emailsListToUpdate, userAccessConfig);
    } else {
      handleUpdateUserAccessConfig(userAccessConfig);
    }
  };

  return (
    <Modal
      title="Modify User Access Config"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleUpdate}>
          Update Config
        </Button>
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "16px" }}>
        {Object.keys(userAccessConfig || {}).map((key) => {
          if (key === "_id") {
            return null;
          }
          const isChecked = userAccessConfig[key];
          return (
            <div
              key={key}
              role="button"
              tabIndex={0}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "8px 12px",
                borderRadius: "4px",
                transition: "background-color 0.2s"
              }}
              onClick={() => {
                handleAccessConfigStateUpdate(key, !isChecked);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleAccessConfigStateUpdate(key, !isChecked);
                  e.preventDefault();
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.02)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <Typography.Text strong>{key}</Typography.Text>
              <Switch
                checked={isChecked}
                onChange={(checked) => {
                  handleAccessConfigStateUpdate(key, checked);
                }}
              />
            </div>
          );
        })}
      </div>

      {isBulkModification && (
        <>
          <Divider />
          <div style={{ marginTop: "16px" }}>
            <Upload customRequest={handleUpload} showUploadList={true}>
              <Button icon={<UploadOutlined />}>Click to Upload Custom Emails File</Button>
            </Upload>
            <div style={{ marginTop: "12px" }}>
              <Typography.Text type="secondary">
                Clicking on <b>Update Config</b> button will modify the access config of{" "}
                <b>{emailsListToUpdate?.length || 0}</b> emails.
              </Typography.Text>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};
export default ModifyUserAccessConfigModal;
